import { render, staticRenderFns } from "./Addressbooks.vue?vue&type=template&id=73dc5cce&"
import script from "./Addressbooks.vue?vue&type=script&lang=js&"
export * from "./Addressbooks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports